export default __webpack_public_path__ + "static/contributor-of-the-month-150a4acced5818fc6cda84f6be977f1b.png";